import { render, staticRenderFns } from "./profit-statistic.vue?vue&type=template&id=3425332e&scoped=true"
import script from "./profit-statistic.vue?vue&type=script&lang=ts"
export * from "./profit-statistic.vue?vue&type=script&lang=ts"
import style0 from "./profit-statistic.vue?vue&type=style&index=0&id=3425332e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425332e",
  null
  
)

export default component.exports